var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 24H17.3333M12.2667 28H19.7333C21.2268 28 21.9736 28 22.544 27.7093C23.0457 27.4537 23.4537 27.0457 23.7093 26.544C24 25.9736 24 25.2268 24 23.7333V8.26667C24 6.7732 24 6.02645 23.7093 5.45603C23.4537 4.95425 23.0457 4.54631 22.544 4.29065C21.9736 4 21.2268 4 19.7333 4H12.2667C10.7732 4 10.0265 4 9.45603 4.29065C8.95425 4.54631 8.54631 4.95425 8.29065 5.45603C8 6.02645 8 6.77319 8 8.26667V23.7333C8 25.2268 8 25.9736 8.29065 26.544C8.54631 27.0457 8.95425 27.4537 9.45603 27.7093C10.0265 28 10.7732 28 12.2667 28Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoard);
export default __webpack_public_path__ + "static/media/on-board.fb1af87da8f8e8f71b8ca6738edb644f.svg";
export { ForwardRef as ReactComponent };